module.exports = __webpack_public_path__ + "img/payzeep-logo.8105711b.png";